import React from 'react';
import { CategoriesContext } from 'modules/components';

export function useCategories() {
  return React.useContext(CategoriesContext);
}
